export function formatPerUnit(value: number | null | undefined, isComparison = false): string {
  if (value === null || value === undefined) {
    return isComparison ? 'N/A' : '$0.00'
  }

  if (value === 0) return '$0.00'

  const sign = value < 0 ? '-' : ''
  const fixedValue = Math.abs(value).toFixed(6)
  const [integerPart, decimalPart = ''] = fixedValue.split('.')

  // Remove trailing zeros from decimal part, but keep at least 2 decimal places
  const trimmedDecimalPart = decimalPart.replace(/0+$/, '')
  const finalDecimalPart = trimmedDecimalPart.length < 2 ? trimmedDecimalPart.padEnd(2, '0') : trimmedDecimalPart

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const formatted = `${sign}$${formattedInteger}.${finalDecimalPart}`

  if (!isComparison) {
    return formatted
  }

  const comparisonSign = value > 0 ? '+' : ''
  return `${comparisonSign}${formatted}`
}

export function formatPerUnitConsistent(
  value: number | null | undefined,
  precision: number,
  currencySymbol = '$',
  isComparison = false
): string {
  if (value === null || value === undefined) {
    return isComparison ? 'N/A' : `${currencySymbol}0.${'0'.repeat(precision)}`
  }

  if (value === 0) return `${currencySymbol}0.${'0'.repeat(precision)}`

  const sign = value < 0 ? '-' : ''
  const fixedValue = Math.abs(value).toFixed(precision)
  const [integerPart, decimalPart = ''] = fixedValue.split('.')

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const formatted = `${sign}${currencySymbol}${formattedInteger}.${decimalPart}`

  if (!isComparison) {
    return formatted
  }

  const comparisonSign = value > 0 ? '+' : ''
  return `${comparisonSign}${formatted}`
}
